/**
 * tdesign v1.8.0
 * (c) 2024 tdesign
 * @license MIT
 */

import { defineComponent, createVNode, computed, ref, toRefs, watch, onMounted } from 'vue';
import { ArrowTriangleUpFilledIcon, ArrowTriangleDownFilledIcon } from 'tdesign-icons-vue-next';
import { i as isNumber_1 } from '../_chunks/dep-a432d90f.mjs';
import { i as isFunction_1 } from '../_chunks/dep-97c71289.mjs';
import props from './props.mjs';
import { usePrefixClass } from '../hooks/useConfig.mjs';
import { useGlobalIcon } from '../hooks/useGlobalIcon.mjs';
import { useTNodeJSX } from '../hooks/tnode.mjs';
import { Skeleton } from '../skeleton/index.mjs';
import Tween from '../_common/js/statistic/tween.mjs';
import { COLOR_MAP } from '../_common/js/statistic/utils.mjs';
import '../_chunks/dep-6f3e4f56.mjs';
import '../_chunks/dep-b1060562.mjs';
import '../_chunks/dep-b333ab93.mjs';
import '../_chunks/dep-8049d2e0.mjs';
import '../_chunks/dep-4efc69ee.mjs';
import '../config-provider/useConfig.mjs';
import '../_chunks/dep-493c38ce.mjs';
import '../_chunks/dep-b56b2dc0.mjs';
import '../_chunks/dep-77f634fb.mjs';
import '../_chunks/dep-28ae3cda.mjs';
import '../_chunks/dep-e50fa7b0.mjs';
import '../_chunks/dep-ae08d6c4.mjs';
import '../_chunks/dep-7211604f.mjs';
import '../_chunks/dep-75df64b1.mjs';
import '../_chunks/dep-48b9a098.mjs';
import '../_chunks/dep-c7e4942d.mjs';
import '../_chunks/dep-0d1bd08c.mjs';
import '../_chunks/dep-c5d88cfe.mjs';
import '../_chunks/dep-25d66c95.mjs';
import '../_chunks/dep-372265bb.mjs';
import '../_chunks/dep-d940e2da.mjs';
import '../_chunks/dep-52c1d6a9.mjs';
import '../_chunks/dep-18bb982b.mjs';
import '../_chunks/dep-c57d8117.mjs';
import '../_chunks/dep-6043e9fc.mjs';
import '../_chunks/dep-5f6c8826.mjs';
import '../_chunks/dep-3a045465.mjs';
import '../_chunks/dep-53dc0ac1.mjs';
import '../_chunks/dep-b6b4eaa3.mjs';
import '../_chunks/dep-881cffb7.mjs';
import '../_chunks/dep-436b338d.mjs';
import '../_common/js/global-config/default-config.mjs';
import '../_common/js/global-config/locale/zh_CN.mjs';
import '../_chunks/dep-2d31a683.mjs';
import '../_chunks/dep-3ddc95d0.mjs';
import '../config-provider/type.mjs';
import '../_chunks/dep-0a6fd248.mjs';
import '../_chunks/dep-7ad89920.mjs';
import '../_chunks/dep-36563716.mjs';
import '../_chunks/dep-b1013215.mjs';
import '../_chunks/dep-91fc304f.mjs';
import '../_chunks/dep-17446155.mjs';
import '../_chunks/dep-8747fcf0.mjs';
import '../utils/render-tnode.mjs';
import '../_chunks/dep-ec227f3f.mjs';
import '../skeleton/skeleton.mjs';
import '../_chunks/dep-a26b9c60.mjs';
import '../skeleton/props.mjs';
import '../utils/withInstall.mjs';
import './style/css.mjs';
import '../skeleton/type.mjs';
import '../_chunks/dep-89b33ff6.mjs';
import '../_chunks/dep-6bcce672.mjs';
import '../_chunks/dep-6d195cc7.mjs';
import '../_common/js/utils/helper.mjs';
import '../_chunks/dep-f7837681.mjs';
import '../_chunks/dep-9c7a32ff.mjs';
import '../_chunks/dep-c45cdd10.mjs';
import '../_chunks/dep-ce88e3c0.mjs';

var _Statistic = defineComponent({
  name: "TStatistic",
  props: props,
  setup: function setup(props2, _ref) {
    var _props2$animation$val, _props2$animation;
    var expose = _ref.expose;
    var COMPONENT_NAME = usePrefixClass("statistic");
    var renderTNodeJSX = useTNodeJSX();
    var _useGlobalIcon = useGlobalIcon({
        ArrowTriangleUpFilledIcon: ArrowTriangleUpFilledIcon,
        ArrowTriangleDownFilledIcon: ArrowTriangleDownFilledIcon
      }),
      ArrowTriangleUpFilledIcon$1 = _useGlobalIcon.ArrowTriangleUpFilledIcon,
      ArrowTriangleDownFilledIcon$1 = _useGlobalIcon.ArrowTriangleDownFilledIcon;
    var trendIcons = {
      increase: createVNode(ArrowTriangleUpFilledIcon$1, null, null),
      decrease: createVNode(ArrowTriangleDownFilledIcon$1, null, null)
    };
    var numberValue = computed(function () {
      return isNumber_1(props2.value) ? props2.value : 0;
    });
    var innerValue = ref((_props2$animation$val = (_props2$animation = props2.animation) === null || _props2$animation === void 0 ? void 0 : _props2$animation.valueFrom) !== null && _props2$animation$val !== void 0 ? _props2$animation$val : props2.value);
    var innerDecimalPlaces = computed(function () {
      var _ref2, _props2$decimalPlaces, _numberValue$value$to;
      return (_ref2 = (_props2$decimalPlaces = props2.decimalPlaces) !== null && _props2$decimalPlaces !== void 0 ? _props2$decimalPlaces : (_numberValue$value$to = numberValue.value.toString().split(".")[1]) === null || _numberValue$value$to === void 0 ? void 0 : _numberValue$value$to.length) !== null && _ref2 !== void 0 ? _ref2 : 0;
    });
    var tween = ref();
    var _toRefs = toRefs(props2),
      value = _toRefs.value;
    var start = function start() {
      var _props2$animation$val2, _props2$animation2;
      var from = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (_props2$animation$val2 = (_props2$animation2 = props2.animation) === null || _props2$animation2 === void 0 ? void 0 : _props2$animation2.valueFrom) !== null && _props2$animation$val2 !== void 0 ? _props2$animation$val2 : 0;
      var to = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : numberValue.value;
      if (from !== to) {
        var _tween$value;
        tween.value = new Tween({
          from: {
            value: from
          },
          to: {
            value: to
          },
          duration: props2.animation.duration,
          onUpdate: function onUpdate(keys) {
            innerValue.value = Number(keys.value.toFixed(innerDecimalPlaces.value));
          },
          onFinish: function onFinish() {
            innerValue.value = to;
          }
        });
        (_tween$value = tween.value) === null || _tween$value === void 0 || _tween$value.start();
      }
    };
    var formatValue = computed(function () {
      var formatValue2 = innerValue.value;
      var decimalPlaces = props2.decimalPlaces,
        separator = props2.separator;
      if (isFunction_1(props2.format)) {
        return props2.format(formatValue2);
      }
      var options = {
        minimumFractionDigits: decimalPlaces || 0,
        maximumFractionDigits: decimalPlaces || 20,
        useGrouping: !!separator
      };
      formatValue2 = formatValue2.toLocaleString(void 0, options).replace(/,|，/g, separator);
      return formatValue2;
    });
    var contentStyle = computed(function () {
      var color = props2.color;
      return {
        color: COLOR_MAP[color] || color
      };
    });
    watch(function () {
      return props2.animationStart;
    }, function (value2) {
      if (props2.animation && value2 && !tween.value) {
        start();
      }
    });
    watch(value, function (value2) {
      if (tween.value) {
        var _tween$value2;
        (_tween$value2 = tween.value) === null || _tween$value2 === void 0 || _tween$value2.stop();
        tween.value = null;
      }
      innerValue.value = value2;
      if (props2.animationStart && props2.animation) {
        start();
      }
    });
    onMounted(function () {
      return props2.animation && props2.animationStart && start();
    });
    expose({
      start: start
    });
    return function () {
      var trendIcon = props2.trend ? trendIcons[props2.trend] : null;
      var prefix = renderTNodeJSX("prefix") || (trendIcon && props2.trendPlacement !== "right" ? trendIcon : null);
      var suffix = renderTNodeJSX("suffix") || (trendIcon && props2.trendPlacement === "right" ? trendIcon : null);
      var title = renderTNodeJSX("title");
      var unit = renderTNodeJSX("unit");
      var extra = renderTNodeJSX("extra");
      return createVNode("div", {
        "class": COMPONENT_NAME.value
      }, [title && createVNode("div", {
        "class": "".concat(COMPONENT_NAME.value, "-title")
      }, [title]), createVNode(Skeleton, {
        "animation": "gradient",
        "theme": "text",
        "loading": !!props2.loading
      }, {
        "default": function _default() {
          return [createVNode("div", {
            "class": "".concat(COMPONENT_NAME.value, "-content"),
            "style": contentStyle.value
          }, [prefix && createVNode("span", {
            "class": "".concat(COMPONENT_NAME.value, "-content-prefix")
          }, [prefix]), createVNode("span", {
            "class": "".concat(COMPONENT_NAME.value, "-content-value")
          }, [formatValue.value]), unit && createVNode("span", {
            "class": "".concat(COMPONENT_NAME.value, "-content-unit")
          }, [unit]), suffix && createVNode("span", {
            "class": "".concat(COMPONENT_NAME.value, "-content-suffix")
          }, [suffix])])];
        }
      }), extra && createVNode("div", {
        "class": "".concat(COMPONENT_NAME.value, "-extra")
      }, [extra])]);
    };
  }
});

export { _Statistic as default };
//# sourceMappingURL=statistic.mjs.map
